import React from 'react'
import Svg from './Svg';
import { defaultGrey } from '../../prop-types';

interface ICheckbox{
  color?: string
  size?: number
}
export default function Checkbox({color = defaultGrey, size}: ICheckbox):  any {
  return (
    <Svg
      size={size}
      xmlns={"http://www.w3.org/2000/svg"}
      paths={[
        { fill:"none", d:"M0 0h24v24H0V0z" },
        {  fill: color, d:"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"},
      ]}
    />
  )
}



